import { FieldPath, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ControlledSelect } from 'components/ControlledFields'
import { ICustomFieldComponentProps } from 'types'
import { mapEnumToOptions } from 'utils/enum-tools'
import { AccountType } from 'generated/graphql'

type AccountTypeFieldProps<T extends FieldValues> = ICustomFieldComponentProps<
  T,
  FieldPath<T>
>

export const AccountTypeField = <T extends FieldValues>({
  name,
  label,
  placeholder
}: AccountTypeFieldProps<T>) => {
  const { t } = useTranslation('common')

  const options = mapEnumToOptions({
    [AccountType.Checking]: t(
      'bankingInformation.fields.accountType.options.checking'
    ),
    [AccountType.Savings]: t(
      'bankingInformation.fields.accountType.options.saving'
    ),
    [AccountType.Trust]: t(
      'bankingInformation.fields.accountType.options.trust'
    )
  })

  return (
    <div>
      <ControlledSelect
        name={name}
        label={label}
        placeholder={placeholder}
        options={options}
      />
      <p className="mt-4 text-xs text-bluePrimary-800">
        {t('bankingInformation.fields.accountType.info')}
      </p>
    </div>
  )
}
